import { render } from "./BrandList.vue?vue&type=template&id=462d3523&scoped=true"
import script from "./BrandList.vue?vue&type=script&lang=js"
export * from "./BrandList.vue?vue&type=script&lang=js"

import "./BrandList.vue?vue&type=style&index=0&id=462d3523&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-462d3523"]])

export default __exports__